import type { JSX } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Icon, type IconName } from '@/components/ui/icon';
import { Heading2 } from '@/components/blocks/typography';

interface NotFoundStateProps {
  title: string;
  description: string;
  icon?: IconName;
  actionLabel?: string;
  onAction?: () => void;
}

export function NotFoundState({
  title,
  description,
  icon = 'error',
  actionLabel,
  onAction,
}: NotFoundStateProps): JSX.Element {
  return (
    <div className="flex min-h-[60vh] items-center justify-center py-12">
      <Card className="w-full max-w-2xl overflow-hidden border border-[var(--border-default)] bg-surface shadow-sm">
        <div className="h-1 w-full bg-brand-blue-100" />
        <div className="flex flex-col gap-6 p-8 text-left sm:flex-row sm:items-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-brand-blue-50 text-brand-blue-500 shadow-sm">
            <Icon name={icon} className="text-3xl" />
          </div>
          <div className="flex-1 space-y-2">
            <p className="text-xs font-semibold uppercase tracking-wide text-text-secondary">
              Nessun risultato
            </p>
            <Heading2 className="text-2xl font-semibold text-text-primary">{title}</Heading2>
            <p className="text-sm text-text-secondary">{description}</p>
            {actionLabel && onAction ? (
              <div className="pt-2">
                <Button variant="secondary" onClick={onAction}>
                  {actionLabel}
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      </Card>
    </div>
  );
}
